import { useContext } from 'react'

import { MarketplaceCard } from 'slab'
import { getMinifiedLocaleCurrencyStringFromMoneyAmount } from 'utils'

import { events, PRICE_QUALIFIER_TEXT, SessionContext } from '../shared'
import { type MarketplaceProductCategory, type MarketplaceProductResponse } from '../shared/types'
import { calculateDiscountDisplay, getPriceCadenceSuffix, getProductBadges } from '../shared/utils'

export const Product = ({ product, position, activeCategory }: {
  product: MarketplaceProductResponse,
  position: number,
  activeCategory: MarketplaceProductCategory
}) => {
  const member = useContext(SessionContext)
  const marketplaceUrl = window.location.pathname
  const isPublicView = member.publicView
  const hasDiscount = !isPublicView && product.discounted_price !== null && product.base_price !== null
  const discount = hasDiscount && product.base_price && product.discounted_price
    ? calculateDiscountDisplay(product.base_price.subunits, product.discounted_price.subunits, product.slug)
    : null
  const priceCadenceSuffix = !isPublicView ? getPriceCadenceSuffix(product.price_cadence) : ''

  const badges = getProductBadges({
    createdAt: product.most_recent_variant_created_at,
    hasDiscount: !!discount,
    comingSoon: product.coming_soon,
  })

  return (
    <MarketplaceCard href={`${marketplaceUrl}/${product.slug}`} onClick={() => events.emitProductClickedEvent(member, product, position, activeCategory)}>
      <MarketplaceCard.Thumbnail
        badges={badges}
        src={product.image_url}
      />
      <MarketplaceCard.Body>
        <MarketplaceCard.Title>
          <div className='flex flex-col gap-[2px]'>
            <span className='body text-gray-500'>{product.product_brand}</span>
            <span className='heading-sm'>{product.name}</span>
          </div>
        </MarketplaceCard.Title>
        <MarketplaceCard.Description>
          {product.description}
        </MarketplaceCard.Description>
        <MarketplaceCard.PriceDetails>
          {!isPublicView && (
            <>
              <MarketplaceCard.Price>
                {product.has_price_qualifier && (
                  <span className='text-base font-normal'>{PRICE_QUALIFIER_TEXT} </span>
                )}
                {getMinifiedLocaleCurrencyStringFromMoneyAmount(product.discounted_price_money_amount ?? product.base_price_money_amount)}
                {priceCadenceSuffix && (
                  <span className='text-base font-normal'>{priceCadenceSuffix}</span>
                )}
              </MarketplaceCard.Price>
              {discount &&
                <>
                  <MarketplaceCard.OriginalPrice>
                    {getMinifiedLocaleCurrencyStringFromMoneyAmount(product.base_price_money_amount)}
                  </MarketplaceCard.OriginalPrice>
                  <MarketplaceCard.Discount>
                    {discount}
                  </MarketplaceCard.Discount>
                </>}
            </>
          )}
        </MarketplaceCard.PriceDetails>
      </MarketplaceCard.Body>
    </MarketplaceCard>
  )
}
